import { Switch } from "antd";
import { useState } from "react";
import InfoItem from "../common/InfoItem";

type Props = {
  type: string;
};
export default function TableCard({ type }: Props) {
  const [status, setStatus] = useState(true);
  return (
    <>
      <div className="bg-white rounded-md border border-extra-light p-6">
        <div
          className={`px-3 py-1.5 rounded-md   ${
            type === "DIGIGO" ? "bg-[#fff4f4]" : "bg-[#F2F5FF]"
          }`}
        >
          <div
            className={`text-3xl font-black    ${
              type === "DIGIGO" ? " text-[#fe7235]" : "text-[#4a71ff]"
            }`}
          >
            {type === "DIGIGO" ? " DIGIgo" : "Ticketing"}
          </div>
        </div>

        <div className="mt-4">
          <div
            className={`flex justify-between items-center border-b  py-2 border-extra-light`}
          >
            <h4 className={`text-extra-gray font-medium `}>Status</h4>

            <div className={`font-medium text-display-body`}>
              <Switch checked={status} onChange={(val) => setStatus(val)} />
              <span className="ml-1">{status ? "Active" : "Inactive"}</span>
            </div>
          </div>

          <div
            className={`flex justify-between items-center border-b  py-2 border-extra-light`}
          >
            <h4 className="text-extra-gray font-medium">Package</h4>

            <div className="font-medium text-[#4A72FF]">Package Name</div>
          </div>

          <InfoItem title="Total User" children="126" />
          <InfoItem title="Package Expire" children="20 Jan, 2026" />
          <InfoItem title="Subscription Plan" children="Yearly" />

          <div
            className={`flex justify-between items-center  py-2 border-extra-light`}
          >
            <h4 className="text-extra-gray font-medium">Renewal Method</h4>

            <div className="font-medium  text-primary italic">
              <span>Auto Payment</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
